export const GET_TOTAL_STATS = 'SA/get_total_stats';
export const GET_GRAPH_STATS = 'SA/get_graph_stats';

export const LEGENDS = [
    { name: 'SENIOR CITIZEN', color: '#5272AA', value: 0 },
    { name: 'PWD', color: '#A3B3F9', value: 0 },
    { name: 'STUDENT', color: '#8EEED7', value: 0 },
    { name: 'SOLO PARENT', color: '#87A1D1', value: 0 },
];
